import { ScrollableArea } from '@approvalmax/ui';
import { Box, Flex } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    flex-flow: column;
    position: relative;
    height: 100%;
    width: 100%;
`;

export const ToolbarContainerBox = styled(Box)`
    border-bottom: 1px solid #cacccd;
`;

export const ToolbarTextFlex = styled(Flex)`
    font-weight: 600;
    font-size: 20px;
    color: #333;
    text-transform: uppercase;
`;

export const Content = styled(ScrollableArea)`
    flex: 1;
    overflow: auto;
`;
